"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlElement = htmlElement;
exports.intentColor = intentColor;
exports.intentIcon = intentIcon;
exports.truncateMiddle = truncateMiddle;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _iconNames = require("../components/icon/iconNames");
var _colors = require("./colors");
var _intent = require("./intent");
var _excluded = ["className", "elementRef"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var intentColorMap = {
  danger: _colors.ColorAliases.DANGER,
  warning: _colors.ColorAliases.WARNING,
  success: _colors.ColorAliases.SUCCESS,
  primary: _colors.ColorAliases.PRIMARY
};
function intentColor(intent) {
  if (intent == null || intent === _intent.Intent.NONE) {
    return undefined;
  }
  return intentColorMap[intent];
}
var intentIconMap = {
  danger: _iconNames.IconNames16.ERROR,
  warning: _iconNames.IconNames16.ERROR,
  success: _iconNames.IconNames16.SUCCESS,
  primary: _iconNames.IconNames16.ERROR
};
function intentIcon(intent) {
  if (intent == null || intent === _intent.Intent.NONE) {
    return undefined;
  }
  return intentIconMap[intent];
}

/**
 * There are cases where important information is at the end of the string and truncating the end isn't helpful.
 * This function solves that.
 * @see https://github.com/kahwee/truncate-middle
 *
 * @param  {string} str         String to be truncated
 * @param  {number} frontLen    Number of characters to be remained in front.
 * @param  {number} backLen     Number of characters to be remained at the back.
 * @param  {string} truncateStr String that is replaced the truncated portion
 * @return {string}             Truncated string. Defaults to '&hellip;' if unspecified.
 */
function truncateMiddle(str, frontLen, backLen) {
  var truncateStr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&hellip;';
  if (str === null) {
    return '';
  }
  var strLen = str.length;
  if (frontLen === 0 && backLen === 0 || frontLen >= strLen || backLen >= strLen || frontLen + backLen >= strLen) {
    return str;
  }
  if (backLen === 0) {
    return str.slice(0, frontLen) + truncateStr;
  }
  return str.slice(0, frontLen) + truncateStr + str.slice(strLen - backLen);
}
/**
 * @see https://github.com/palantir/blueprint/blob/%40blueprintjs/core%403.54.0/packages/core/src/components/html/html.tsx
 */
function htmlElement(tagName, tagClassName) {
  return function (props) {
    // eslint-disable-next-line react/prop-types
    var className = props.className,
      elementRef = props.elementRef,
      htmlProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/React.createElement(tagName, _objectSpread(_objectSpread({}, htmlProps), {}, {
      className: (0, _classnames.default)(tagClassName, className),
      ref: elementRef
    }));
  };
}